const emptyStep = () => ({ enabled: false, durationSeconds: 0, message: '' });

const emptyChannel = () => ({
  conversationTimeLimit: {
    enabled: false,
    durationSeconds: 0,
    destinationType: 'end',
    forwardTo: '',
    agentMessageBeforeEnding: { enabled: false, message: '' },
  },
  inactivity: {
    checkIn: emptyStep(),
    goodbye: emptyStep(),
    endConversation: { enabled: false, durationSeconds: 0 },
  },
});

export function normalizeTimeoutSettings(ts = {}) {
  return {
    chat: { ...emptyChannel(), ...(ts.chat || {}) },
    voice: { ...emptyChannel(), ...(ts.voice || {}) },
  };
}

export default normalizeTimeoutSettings;
